export default [
  [`Размеры`, `M`, `L`, `XL`],
  [`Длина изделия`, `69`, `72`, `75`],
  [`Длина рукава`, `81`, `81`, `81`],
  [`Полуобхват груди`, `64`, `66`, `68`]
];
